// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import '@/styles/index.scss' // global css

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getCookie } from '@/utils/auth' // getToken from cookie
import { getQueryString } from '@/utils/util'

import '@/styles/reset.scss'

import axios from 'axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons' // icon
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import './assets/font/material-icons.css'
Vue.use(ElementUI)
Vue.use(MuseUI)

Vue.config.productionTip = false

let startApp = function () {
  if (document.documentElement.clientWidth > document.documentElement.clientHeight) {
    window.phone = false
  } else {
    window.phone = true
  }
  const url = '../'
  axios.get(`${url}static/config.json`).then((res) => {
    if (process.env.NODE_ENV === 'development') {
      Vue.prototype.BASE_URL = 'https://safety.demo.oiluser.net/node'
    } else {
      Vue.prototype.BASE_URL = `${res.data.host}` // 基础地址
    }

    axios.get(`${res.data.host}/base-config`).then((res2) => {
      Vue.prototype.APP_ID = `${res2.data.appid}`
    })

    NProgress.configure({ showSpinner: false }) // NProgress configuration
    const whiteList = ['/login', '/check', '/backstagemanage/companylogin'] // 不重定向白名单
    router.beforeEach((to, from, next) => {
      NProgress.start()
      if (to.path.indexOf('backstagemanage') !== -1) { // 公司后台
        if (getCookie('admintoken')) {
          if (to.path === '/backstagemanage/companylogin') {
            next()
            NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
          } else {
            next()
          }
        } else {
          if (whiteList.indexOf(to.path) !== -1) {
            next()
          } else {
            next(`/backstagemanage/companylogin`) // 否则全部重定向到登录页
            NProgress.done()
          }
        }
      } else {
        if (getCookie('token')) {
          if (to.path === '/login') {
            next()
            NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
          } else {
            next()
          }
        } else {
          if (whiteList.indexOf(to.path) !== -1) {
            next()
          } else {
            let demo = false
            try {
              demo = getQueryString('demo')
            } catch (error) {
              demo = false
            }
            if (demo) {
              const data = {
                username: 'demo_demo',
                password: '123456'
              }
              store.dispatch('Login', data).then(res => {
                if (res) {
                  next('/dashboard')
                }
              })
            } else {
              next(`/login`) // 否则全部重定向到登录页
              NProgress.done()
            }
          }
        }
      }
    })
    router.afterEach(() => {
      NProgress.done() // 结束Progress
    })
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  })
}
startApp()



// WEBPACK FOOTER //
// ./src/main.js